import IconNameEnum from "constants/IconNameEnum";
import PermissionEnum from "constants/PermissionEnum";
import IAction from "models/IAction";
import IStore from "models/IStore";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { connect, DispatchProp } from "react-redux";
import { selectRequesting } from "selectors/requesting/RequestingSelector";
import CercaAction from "stores/ricerca/CercaAction";
import CercaDettalgioSimulazioneModel from "stores/ricerca/models/CercaDettalgioSimulazioneModel";
import UserPermissionModel from "stores/utente/models/UserPermissionModel";
import FormatUtility from "utilities/FormatUtility";
import BaseModal from "views/components/base-content/BaseModal";
import BaseButton from "views/components/base-form/BaseButton";
import LoadingIndicator from "views/components/loading-indicator/LoadingIndicator";
import ValidationUtility from "../../utilities/ValidationUtility";
import FunctionEnum from "../../constants/FunctionEnum";

interface IProps {
    readonly handlePopup: () => void;
    readonly open: boolean;
}

interface IState {}

interface IStateToProps {
    readonly dettaglioSimulazione?: CercaDettalgioSimulazioneModel;
    readonly isRequesting: boolean;
    readonly userPermissions: UserPermissionModel;
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    dettaglioSimulazione: state.cerca.cercaDettalgioSimulazioneModel,
    isRequesting: selectRequesting(state, [CercaAction.REQUEST_FIND_SIMULATION]),
    userPermissions: state.utente.responsePermissions,
});

export class CercaSimulazioneDettaglio extends React.Component<
    IProps & IStateToProps & DispatchProp<IAction<any>>,
    IState
> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>, state: IState) {
        super(props);
    }

    private getModalForm = () => {
        const { dettaglioSimulazione, isRequesting, userPermissions } = this.props;

        return (
            <>
                {isRequesting ? (
                    <LoadingIndicator className="mb-3" isActive={true} />
                ) : (
                    <>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Denominazione simulazione:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.name ?? "-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>N° Simulazione:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.id ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Agente Produttore:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.agent ?? "-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Canale:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.channel ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Segmento:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.segment ?? "-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Tipo richiesta:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.requestType ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>ATC:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.atc ?? "-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Tipo cliente:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioSimulazione?.administrativeCategory ?? "-"}
                                </span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Rata:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioSimulazione?.payment
                                        ? FormatUtility.currency(dettaglioSimulazione.payment)
                                        : "-"}
                                </span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Durata:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.duration ?? "-"} mesi</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Importo:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{"-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Montante:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioSimulazione?.amount
                                        ? FormatUtility.currency(dettaglioSimulazione?.amount)
                                        : "-"}
                                </span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>RV:</span>
                            </Col>
                            <Col md={8} lg={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.rv ?? "-"}</span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>RC:</span>
                            </Col>
                            <Col md={8} lg={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.rc ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Provvigioni:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioSimulazione?.commissions !== null
                                        ? FormatUtility.currency(dettaglioSimulazione?.commissions || 0)
                                        : "-"}
                                </span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>Saldo:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioSimulazione?.balance
                                        ? FormatUtility.currency(dettaglioSimulazione?.balance)
                                        : "-"}
                                </span>
                            </Col>
                        </Row>
                        {ValidationUtility.verificaFn(FunctionEnum.FN_BPP) && (
                            <Row className="align-items-center">
                                <Col md={4} lg={6} xl={3}>
                                    <span>Provvigioni erogate:</span>
                                </Col>
                                <Col md={8} lg={6} xl={3}>
                                    <span className="font-weight-bold">
                                        {dettaglioSimulazione?.provvigioniCalcolate !== null
                                            ? FormatUtility.currency(dettaglioSimulazione?.provvigioniCalcolate || 0)
                                            : "-"}
                                    </span>
                                </Col>
                            </Row>
                        )}
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3}>
                                <span>Nome prodotto:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">{dettaglioSimulazione?.product ?? "-"}</span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            {ValidationUtility.verificaFn(FunctionEnum.FN_BPP) && (
                                <>
                                    <Col md={4} lg={6} xl={3} className="dettaglio-padding-left">
                                        <span>TAN BASE:</span>
                                    </Col>
                                    <Col md={8} lg={6} xl={3}>
                                        <span className="font-weight-bold">
                                            {dettaglioSimulazione?.tanBase !== undefined
                                                ? FormatUtility.percentage(
                                                      dettaglioSimulazione?.tanBase ?? 0,
                                                      !ValidationUtility.verificaFn(FunctionEnum.FN_BPP) ? 4 : 2
                                                  )
                                                : "-"}
                                        </span>
                                    </Col>
                                </>
                            )}

                            {userPermissions.permissions.find((item) =>
                                item.includes(PermissionEnum.CQS_Prev_VediIRR)
                            ) && (
                                <>
                                    <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                        <span>IRR:</span>
                                    </Col>
                                    <Col md={8} lg={6} xl={3}>
                                        <span className="font-weight-bold">
                                            {dettaglioSimulazione?.irr !== undefined
                                                ? FormatUtility.percentage(dettaglioSimulazione?.irr, 2)
                                                : "-"}
                                        </span>
                                    </Col>
                                </>
                            )}
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left">
                                <span>TAN:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioSimulazione?.tan !== undefined
                                        ? FormatUtility.percentage(
                                              dettaglioSimulazione?.tan ?? 0,
                                              !ValidationUtility.verificaFn(FunctionEnum.FN_BPP) ? 4 : 2
                                          )
                                        : "-"}
                                </span>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left">
                                <span>TAEG:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioSimulazione?.taeg !== undefined
                                        ? FormatUtility.percentage(dettaglioSimulazione?.taeg)
                                        : "-"}
                                </span>
                            </Col>
                            <Col md={4} lg={6} xl={3} className="dettaglio-padding-left pl-5">
                                <span>TEG:</span>
                            </Col>
                            <Col md={8} lg={6} xl={3}>
                                <span className="font-weight-bold">
                                    {dettaglioSimulazione?.teg !== undefined
                                        ? FormatUtility.percentage(dettaglioSimulazione?.teg)
                                        : "-"}
                                </span>
                            </Col>
                        </Row>
                    </>
                )}
            </>
        );
    };

    public render(): JSX.Element {
        const { open, handlePopup } = this.props;
        const modalForm = this.getModalForm();

        return (
            <BaseModal
                show={open}
                onHideHandler={handlePopup}
                closeOnOutClick={false}
                centered={true}
                title="Dettaglio simulazione"
                bodyLeft={true}
                body={<>{modalForm}</>}
                size="xl"
                footer={
                    <>
                        <BaseButton
                            icon={IconNameEnum.Ko}
                            type="button"
                            color="grey"
                            label={"Chiudi"}
                            onClickHandler={handlePopup}
                        />
                    </>
                }
            />
        );
    }
}

export { CercaSimulazioneDettaglio as Unconnected };
export default connect(mapStateToProps)(CercaSimulazioneDettaglio);
